import { Widget } from "blue-widgets";

class ProductListing extends Widget {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {
        let selectedTag;
        let selectedSortOrder = "";
        let subCategory = "";
        let mainCategory = "";
        const currentPage = 1;
        const productsAPI = "/umbraco/api/productapi/GetFilteredProductsListing";
        const categoriesAPI = "/umbraco/api/productapi/GetCategories?Query=";
        let culture = this.el.getAttribute("data-culture");
        let pageId = this.el.getAttribute("data-page-id");
        getCategoryFromURL();

        function getCategoryFromURL() {
            const url = new URL(window.location.href);
            if (url.search) {
                let searchTerm = url.search.split("Category=")[1];
                searchTerm = decodeURIComponent(searchTerm);
                const subCategoryURL = searchTerm.replace(/%20/g, " ");
                subCategory = subCategoryURL;
            }
            const pathname = url.pathname.split("/").filter((part) => part !== "");
            mainCategory = pathname[pathname.length - 1];

            fetchCategoryData();
        }

        function fetchCategoryData() {
            const apiUrl = `${categoriesAPI}${mainCategory}`;
            (async () => {
                try {
                    const response = await fetch(apiUrl, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        },
                    });
                    const data = await response.json();
                    createCategoriesAccordion(data);
                    fetchProductsLoad();
                } catch (error) {
                    console.error("Error fetching categories:", error);
                }
            })();
        }

        function getSelectedCategories() {
            const categoryCheckboxes = document.querySelectorAll(
                ".product-listing__left input[type='checkbox']:checked"
            );

            const selectedCategories = Array.from(categoryCheckboxes)
                .filter((checkbox) => !checkbox.id.includes("category-all"))
                .map((checkbox) => checkbox.value);
            return selectedCategories;
        }

        function fetchProductsLoad(page = 1) {
            const data = {
                pageId: Number.parseInt(pageId),
                categories: [],
                page: page,
                pageSize: 99999,
                culture: culture,
            };
            fetch(`${productsAPI}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
                .then(handleResponse)
                .then((responseData) => {
                    if (subCategory.length !== 0) {
                        fetchProducts();
                    } else {
                        updateProductListing(responseData);
                    }
                    createTags(responseData);
                })
                .catch((error) => {
                    console.error("Error fetching products:", error);
                });
        }

        function handleResponse(response) {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.json();
        }

        function fetchProducts(page = 1, sortOption = "", tag = selectedTag) {
            const selectedCategories = getSelectedCategories();
            const data = {
                pageId: Number.parseInt(pageId),
                categories: selectedCategories,
                page: page,
                pageSize: 99999,
                sortOption: sortOption,
                tag: tag,
                culture: culture,
            };
            fetch(`${productsAPI}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then(updateProductListing)
                .catch((error) => console.error("Error fetching products:", error));
        }

        function createCategoriesAccordion(data) {
            createSubCategoryBtns(data);
            const accordionParents = document.querySelectorAll(
                ".product-listing__container .accordion-parent"
            );
            accordionParents.forEach((parent, indexParent) => {
                const accordionTitle = parent.querySelector(".accordion__btn-parent");
                accordionTitle.childNodes[2].textContent = data.title;
                data.subCategoriesList.forEach((category, indexCategory) => {
                    createSubCategories(category, parent, indexCategory, indexParent);
                });
            });
            if (subCategory.length !== 0 && subCategory !== undefined) {
                let subCategoryContainer = document.querySelectorAll(
                    `[data-select-all="${subCategory}"] .accordion__content-inner input[type='checkbox']`
                );
                if (subCategoryContainer.length === 0) {
                    subCategoryContainer = document.querySelectorAll(
                        `.accordion__content-inner input[type='checkbox'][value="${subCategory}"]`
                    );
                }
                toggleAllCheckboxes(subCategoryContainer, subCategory);
            }
        }

        const createSubCategories = (
            category,
            parent,
            indexCategory,
            indexParent
        ) => {
            const parentContainer = parent;
            let accordionGroup;
            if (
                parentContainer.querySelector(
                    `[data-title="${category.tag}"] .accordion-group .accordion-group`
                )
            ) {
                accordionGroup = parentContainer.querySelector(
                    `[data-title="${category.tag}"] .accordion-group .accordion-group`
                );
            } else {
                accordionGroup = parentContainer.querySelector(".accordion-group");
            }

            const checkboxAll = createCheckboxAll(
                "All",
                `category-all-${indexCategory}${indexParent}`,
                category
            );
            const accordionChild = createAccordionChild(
                category,
                indexCategory,
                indexParent
            );
            const accordionChildSelector = accordionChild.querySelector(
                ".accordion__content-inner-child"
            );

            if (category && category.subCategoriesLists && category.subCategoriesLists.length > 0) {
                accordionChildSelector.appendChild(checkboxAll);
            }

            accordionGroup.appendChild(accordionChild);
            if (category.subCategoriesLists.length > 0) {
                category.subCategoriesLists.forEach((item, index) => {
                    if (
                        item.subCategoriesLists !== null &&
                        item.subCategoriesLists.length > 0
                    ) {
                        const parent = document.querySelectorAll(
                            `[data-select-all="${category.tag}"] .accordion__content-inner-child`
                        );
                        const lastItem = parent[parent.length - 1];
                        const id = 1;
                        const newAccordionGroup = createAccordionGroup(id, item.title);
                        lastItem.appendChild(newAccordionGroup);
                        const newGroup = lastItem.querySelector(
                            ".accordion__content-parent .accordion-group"
                        );
                        createSubCategories(
                            item,
                            newGroup,
                            indexCategory + 12,
                            indexParent + 12
                        );
                    } else {
                        const mainCategoryCheckbox = createCheckbox(
                            item.title,
                            `main-category-${indexCategory}${indexParent}`,
                            item.tag
                        );
                        accordionChildSelector.appendChild(mainCategoryCheckbox);
                    }
                });
            }
            syncCheckboxes();
        };

        function createAccordionGroup(id, title) {
            const accordionGroup = document.createElement("div");
            accordionGroup.classList.add("accordion-group");
            accordionGroup.setAttribute("data-widget", "ExpandableGroup");
            accordionGroup.setAttribute("role", "group");
            accordionGroup.setAttribute("data-title", `${title}`);

            const accordionParent = createAccordionParent(id);
            accordionGroup.appendChild(accordionParent);

            return accordionGroup;
        }

        function createAccordionParent(id) {
            const accordionParent = document.createElement("div");
            accordionParent.classList.add("accordion", "accordion-parent");
            accordionParent.setAttribute("data-widget", "Expandable");

            const accordionContentParent = createAccordionContentParent(id);
            accordionParent.appendChild(accordionContentParent);

            return accordionParent;
        }

        function createAccordionContentParent(id) {
            const accordionContentParent = document.createElement("div");
            accordionContentParent.classList.add("accordion__content-parent");
            accordionContentParent.setAttribute("id", `item${id}-content`);
            accordionContentParent.setAttribute("role", "region");
            accordionContentParent.setAttribute("aria-hidden", "true");

            const accordionContentInner = document.createElement("div");
            accordionContentInner.classList.add(
                "accordion__content-inner",
                "accordion__content-inner-parent"
            );

            const nestedAccordionGroup = document.createElement("div");
            nestedAccordionGroup.classList.add("accordion-group");
            nestedAccordionGroup.setAttribute("data-widget", "ExpandableGroup");
            nestedAccordionGroup.setAttribute("role", "group");

            accordionContentInner.appendChild(nestedAccordionGroup);
            accordionContentParent.appendChild(accordionContentInner);

            return accordionContentParent;
        }

        const toggleAllCheckboxes = (parentContainer, checkboxAll) => {
            parentContainer.forEach((checkbox) => {
                if (checkboxAll) {
                    checkbox.checked = true;
                } else {
                    checkbox.checked = false;
                }
            });
            fetchProducts();
        };

        const createCheckboxAll = (label, id, category) => {
            const subcategoryAllCheckboxList = [];
            category.subCategoriesLists.forEach((item) => {
                subcategoryAllCheckboxList.push(item.tag);
            });
            const wrapper = document.createElement("div");
            wrapper.classList.add("checkbox", `${id}`);
            wrapper.setAttribute("data-widget", "Checkbox");
            wrapper.setAttribute("data-name", `${category.title}`);

            const input = document.createElement("input");
            input.type = "checkbox";
            input.id = id;
            input.name = "categories";
            input.value = category.title;

            const labelElement = document.createElement("label");
            labelElement.setAttribute("for", id);
            labelElement.textContent = label;
            labelElement.tabIndex = 0;

            wrapper.addEventListener("change", () => {
                const checkboxesParent = document.querySelectorAll(
                    `[data-select-all="${category.tag}"] .accordion__content-inner input[type='checkbox']`
                );
                toggleAllCheckboxes(checkboxesParent, input.checked);
                getSelectedCategories();
            });
            wrapper.appendChild(input);
            wrapper.appendChild(labelElement);

            return wrapper;
        };

        function createCheckbox(label, id, value) {
            const wrapper = document.createElement("div");
            wrapper.classList.add("checkbox");
            wrapper.setAttribute("data-widget", "Checkbox");

            const input = document.createElement("input");
            input.type = "checkbox";
            input.id = id + value;
            input.name = "categories";
            input.value = value;

            const labelElement = document.createElement("label");
            labelElement.setAttribute("for", id + value);
            labelElement.textContent = label;
            labelElement.tabIndex = 0;

            wrapper.appendChild(input);
            wrapper.appendChild(labelElement);

            wrapper.addEventListener("change", () => {
                const checkboxAll = wrapper.parentNode.firstElementChild.querySelector(
                    "input[type='checkbox']"
                );
                if (!input.checked) {
                    checkboxAll.checked = false;
                }
                fetchProducts();
            });
            return wrapper;
        }

        function createAccordionChild(category, indexCategory, indexParent) {
            const accordionChild = document.createElement("div");
            accordionChild.classList.add("accordion", "accordion-child");
            accordionChild.setAttribute("data-widget", "Expandable");
            accordionChild.setAttribute("data-select-all", `${category.tag}`);

            const buttonWrapper = document.createElement("div");
            buttonWrapper.classList.add("accordion__trigger");
            buttonWrapper.setAttribute("aria-controls", `item${indexParent}-content`);
            buttonWrapper.setAttribute("data-accordion-trigger", "true");

            const childBtn = document.createElement("button");
            childBtn.classList.add("subtitle2");
            childBtn.setAttribute("aria-haspopup", "true");
            childBtn.setAttribute("aria-expanded", "true");

            childBtn.innerHTML = `<i class="icon icon-arrow_down " aria-hidden="true"></i>${category.title}`;

            const contentChild = document.createElement("div");
            contentChild.classList.add("accordion__content-child");
            contentChild.setAttribute("id", `item${indexParent}-content`);
            contentChild.setAttribute("role", "region");
            contentChild.setAttribute("aria-hidden", "false");
            contentChild.setAttribute("tabindex", "-1");
            contentChild.style.maxHeight = "800px";
            const contentInnerChild = document.createElement("div");
            contentInnerChild.classList.add(
                "accordion__content-inner",
                "accordion__content-inner-child"
            );
            const icon = childBtn.querySelector(".icon");
            icon.style.transform = "rotate(180deg)";

            buttonWrapper.addEventListener("click", (event) => {
                if (event.target === childBtn) {
                    const isExpanded = childBtn.getAttribute("aria-expanded") === "true";
                    if (isExpanded) {
                        contentChild.style.maxHeight = "0px";
                        icon.style.transform = "rotate(0deg)";
                        accordionChild.classList.remove("isOpen");
                        childBtn.setAttribute("aria-expanded", "false");
                    } else {
                        contentChild.style.maxHeight = "800px";
                        icon.style.transform = "rotate(180deg)";
                        accordionChild.classList.add("isOpen");
                        childBtn.setAttribute("aria-expanded", "true");
                    }
                }
            });

            buttonWrapper.addEventListener("keydown", (event) => {
                if (
                    event.target === childBtn &&
                    (event.key === "Enter" || event.key === " ")
                ) {
                    event.preventDefault();
                    const isExpanded = childBtn.getAttribute("aria-expanded") === "true";
                    if (isExpanded) {
                        accordionChild.classList.remove("isOpen");
                        childBtn.setAttribute("aria-expanded", "false");
                    } else {
                        accordionChild.classList.add("isOpen");
                        childBtn.setAttribute("aria-expanded", "true");
                    }
                }
            });
            buttonWrapper.appendChild(childBtn);
            accordionChild.appendChild(buttonWrapper);

            contentChild.appendChild(contentInnerChild);
            buttonWrapper.parentNode.insertBefore(
                contentChild,
                buttonWrapper.nextSibling
            );

            return accordionChild;
        }

        function updateProductListing(response) {
            const productContainer = document.querySelector(
                ".product-listing__products"
            );
            const productCountElement = document.querySelector("#productCount");
            if (!productContainer) {
                return;
            }
            productContainer.innerHTML = "";
            if (productCountElement) {
                const resultsText = productCountElement.dataset.resultsText;

                let itemCount = 0;
                if (response && response.items) {
                    itemCount = response.items.length;
                }

                productCountElement.textContent = `${itemCount} ${resultsText}`;
            }
            if (response && response.items) {
                response.items.forEach((product) => {
                    let productCardHTML = `<a href="${product.callToActionLink.url}" class='product-listing__card'><div class='product-listing__card-labels'>`;

                    product.tags?.slice(0, 2).forEach((tag) => {
                        productCardHTML += `<span class="label label--${tag.color} label--product-listing">${tag.title}</span>`;
                    });
                    productCardHTML += "</div><div class='product-listing__card-image'>";
                    if (product.productImage) {
                        productCardHTML += `<img src="${product.productImage.desktopSource}" srcset="${product.productImage.desktopSource} 1x, ${product.productImage.desktop2xSource} 2x" alt="${product.productImage.alternateText}" width="208" height="152" />`;
                    }
                    productCardHTML += `</div><div class="product-listing__card-text"><p class="h6">${product.productName}</p><p class="body2">${product.description}</p><p class="overline">${product.fromUnitPrice}</p></div></a>`;
                    productContainer.innerHTML += productCardHTML;
                });
            }
        }

        const createTags = (response) => {
            const relatedLabelsContainer = document.querySelector(
                ".product-listing__labels .product-listing__labels-row"
            );
            relatedLabelsContainer.innerHTML = "";
            const uniqueTags = new Set();
            response.items.forEach((product) => {
                product.tags?.slice(0, 2).forEach((tag) => {
                    uniqueTags.add(tag.title);
                });
            });
            uniqueTags.forEach((tag) => {
                const radio = document.createElement("input");
                radio.type = "radio";
                radio.name = "tag";
                radio.value = tag;
                radio.id = `tag-${tag}`;

                const label = document.createElement("label");
                label.textContent = tag;
                label.className = "label label--border-only";
                label.htmlFor = `tag-${tag}`;

                let selectedRadioTag = "";

                radio.addEventListener("click", () => {
                    if (selectedRadioTag !== radio.value || selectedTag === "") {
                        radio.checked = true;
                        selectedRadioTag = radio.value;
                        selectedTag = radio.value;
                        fetchProducts(1, "", radio.value);
                    } else {
                        radio.checked = false;
                        selectedTag = "";
                        fetchProducts(1, "", "");
                    }
                });

                relatedLabelsContainer.appendChild(radio);
                relatedLabelsContainer.appendChild(label);
            });
        };

        const createSubCategoryBtns = (data) => {
            const relatedCategoriesContainer = document.querySelector(
                ".product-listing__categories"
            );
            if (relatedCategoriesContainer !== null) {
                data.subCategoriesList.slice(0, 5).forEach((category) => {
                    const button = document.createElement("button");
                    button.classList.add("product-listing__categories-item", "subtitle1");

                    button.textContent = category.title;
                    button.addEventListener("click", () => {
                        const checkboxesParent = document.querySelectorAll(
                            `[data-select-all="${category.title}"] .accordion__content-inner input[type='checkbox']`
                        );
                        const checkboxAll = document.querySelector(
                            `[data-select-all="${category.title}"] .accordion__content-inner input[value='${category.title}']`
                        );
                        toggleAllCheckboxes(checkboxesParent, !checkboxAll.checked);
                    });

                    const imageWrapper = document.createElement("div");
                    const image = document.createElement("img");
                    image.src =
                        category.image.desktopSource !== null
                            ? category.image.desktopSource
                            : "";
                    image.alt = category.title;
                    image.width = 78;
                    image.height = 105;
                    imageWrapper.appendChild(image);
                    button.appendChild(imageWrapper);

                    relatedCategoriesContainer.appendChild(button);
                });
            }
        };

        function syncCheckboxes() {
            const allCheckboxes = document.querySelectorAll(
                ".accordion__content-inner input[type='checkbox']"
            );
            const checkedValues = {};
            allCheckboxes.forEach((checkbox) => {
                const value = checkbox.value;
                checkbox.addEventListener("change", function () {
                    if (this.checked) {
                        if (!checkedValues[value]) {
                            checkedValues[value] = true;
                            const duplicates = document.querySelectorAll(
                                `.accordion__content-inner input[type='checkbox'][value='${value}']:not(:checked)`
                            );
                            duplicates.forEach((duplicate) => {
                                duplicate.checked = true;
                            });
                        }
                    } else {
                        delete checkedValues[value];
                        const duplicates = document.querySelectorAll(
                            `.accordion__content-inner input[type='checkbox'][value='${value}']:checked`
                        );
                        duplicates.forEach((duplicate) => {
                            duplicate.checked = false;
                        });
                    }
                });
            });
        }
        const sortSelect = document.querySelector(
            ".product-listing__sort .select select"
        );

        sortSelect.addEventListener("change", () => {
            if (sortSelect.value !== selectedSortOrder) {
                selectedSortOrder = sortSelect.value;
                fetchProducts(currentPage, selectedSortOrder, selectedTag);
            }
        });
    }
}

export default ProductListing;
